var personDetails = {};

( function ( $ ) {

    personDetails.init = function() {
        personDetails.eventClick();
    };

    personDetails.eventClick = function() {
        $( ".js-person-details .image, .js-person-details .profile" ).click(function(e) {

            if ( Viewport.documentWidth().width > 992 ) {
                $( ".js-person-details" ).removeClass('has-hover');
                $(this).parent('.js-person-details').addClass('has-hover');
                e.stopPropagation();
            }
        });

        $(document).click(function(){
            if ( Viewport.documentWidth().width > 992 ) {
                $( ".js-person-details" ).removeClass('has-hover');
            }
        });

        $( ".js-person-details .image" ).click(function() {
          $(this).closest('.person-list').addClass('active').siblings('.person-list').removeClass('active');
        });

        $( ".js-person-details" ).click(function() {
          console.log($(this).parent('.person-list'));

            var personDetails = $( this ).html();
            if ( Viewport.documentWidth().width < 991 ) {
                $("#person-modal .modal-body").html('');
                $("#person-modal .modal-body").html(personDetails);
                $("#person-modal").modal();
            }
        });

    };

    $( window ).on( 'resize', function(){
        if ( Viewport.documentWidth().width < 991 ) {
            $( ".js-person-details" ).removeClass('has-hover');
        }
    });


    personDetails.init();
} )( jQuery );
